import { render } from "./BudgetSmall.vue?vue&type=template&id=52045f9a&ts=true"
import script from "./BudgetSmall.vue?vue&type=script&lang=ts"
export * from "./BudgetSmall.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__